module.exports = __webpack_public_path__ + "static/media/recaptcha.14c9c3f4.png";